<template>
	<div class='tw-flex-col tw--mx-3'>
		<div class="px-3 tw-w-3/3">
			<title-header class="tw-my-4">
				<v-layout row wrap class="tw-justify-between tw-items-center">
					<div class="wrapper-btns">
						<v-btn
							color="primary btn-action"
							@click="returnPage">
							<img
								src="/static/img/icons/btn-right-arrow.webp"
								alt="Atrás"
								class="mr-4"
							/>
							Atrás
						</v-btn>
					</div>
					<div class="wrapper-btns tw-mr-10">
						<app-tooltip-button
							text="Descargar reporte en EXCEL"
							img="/static/img/icons/excel.webp"
							:disabled="!descriptionData.urlFile"
							@click-icon="downloadReportExcel({ type: 'xlsx', contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel' })"
						></app-tooltip-button>
						<app-tooltip-button
							text="Descargar reporte en PDF"
							img="/static/img/icons/pdf.svg"
							:disabled="!descriptionData.urlFile"
							@click-icon="downloadReport"
						></app-tooltip-button>
					</div>
				</v-layout>
			</title-header>
			<p-card class="tw-flex tw-gap-x-10 tw-mb-4">
				<div class="px-3 tw-w-1/2">
					<p class="header-title">Organización / Empresa: <span class="header-job">{{ descriptionData.subsidiary.length > 0 ? descriptionData.subsidiary[0].company.name : '' }}</span></p>
					<p class="header-title">Nombre del Puesto: <span class="header-job">{{ jobSelected.name }}</span></p>
					<p class="header-title">Rol: <span class="header-job">{{ jobSelected.role.name }}</span></p>
					<!-- <p class="header-title">Nivel Jerárquico: <span class="header-job">{{ jobInfo.levelHierarchy.name }}</span></p> -->
					<p class="header-title">Puesto al que reemplaza: <span class="header-job">{{ getJobsHeReplaces }}</span></p>
					<p class="header-title">Programa / Área: <span class="header-job">{{ jobSelected.areas.name }}</span></p>
				</div>
				<div class="px-3 tw-w-1/2">
					<p class="header-title">Sucursal/es: <span class="header-job" > {{ getSubsidiaries }}</span></p>
					<p class="header-title">Idioma inglés: <span class="header-job">{{ jobSelected.englishLevel.name }}</span></p>
					<p class="header-title">Jefe Inmediato: <span class="header-job">{{ jobSelected.additionalInformation && jobSelected.additionalInformation.immediateBoss
						? jobSelected.additionalInformation.immediateBoss.name : jobInfo.fatherName.name }}</span></p>
					<p class="header-title">Puesto que lo reemplaza: <span class="header-job">{{ getJobsItReplaces }}</span></p>
				</div>
			</p-card>
			<p-card class="tw-flex-auto tw-flex tw-justify-between tw-my- tw-gap-x-20">
				<div class="tw-flex-1 tw-w-full tw-p-3 column">
					<div v-if="stepsData.MSJ" class="tw-flex tw-flex-col tw-mb-8">
						<div class="tw-flex tw-w-full tw-justify-between tw-gap-x-4">
							<button
							class="btn-primary">
							1
							</button>
							<p-title-header :title="stepsData.MSJ.name" gray class="tw-w-full">
								<div class="tw-flex tw-w-full tw-justify-end tw-items-center" style="height: auto;">
									<app-tooltip-button
										text="¿Para qué está este puesto? ¿Cuál es el principal resultado, servicio o beneficio de este puesto?"
										img="/static/img/circle-question.svg"
										disabled
									></app-tooltip-button>
								</div>
							</p-title-header>
						</div>
						<table>
							<tr>
								<th style="width: 30%;">VERBO</th>
								<th style="width: 70%;">COMPLEMENTO</th>
							</tr>
							<tr v-for="(msj, index) in stepsData.MSJ.description" :key="index">
								<td class="verb">{{ msj.verb ? msj.verb.name: '' }}</td>
								<td class="complement">{{ msj.complement }}</td>
							</tr>
						</table>
					</div>
					<div v-if="stepsData.PSA" class="tw-flex tw-flex-col tw-my-8">
						<div class="tw-flex tw-w-full tw-justify-between tw-gap-x-4">
							<button
							class="btn-primary">
							2
							</button>
							<p-title-header :title="stepsData.PSA.name" gray class="tw-w-full">
								<div class="tw-flex tw-w-full tw-justify-end tw-items-center" style="height: auto;">
									<app-tooltip-button
										text="Elegir y compilar aquí las principales actividades del puesto."
										img="/static/img/circle-question.svg"
										disabled
									></app-tooltip-button>
								</div>
							</p-title-header>
						</div>
						<table>
							<tr>
								<th style="width: 30%;">ACTIVIDAD</th>
								<th style="width: 70%;">COMPLEMENTO</th>
							</tr>
							<tr v-for="(psa, index) in stepsData.PSA.description" :key="index">
								<td class="verb">{{ psa.activity.name }}</td>
								<td class="complement">{{ psa.complement }}</td>
							</tr>
						</table>
					</div>
					<div v-if="stepsData.RNW" class="tw-flex tw-flex-col tw-my-8">
						<div class="tw-flex tw-w-full tw-justify-between tw-gap-x-4">
							<button
							class="btn-primary">
							3
							</button>
							<p-title-header :title="stepsData.RNW.name" gray class="tw-w-full">
								<div class="tw-flex tw-w-full tw-justify-end tw-items-center" style="height: auto;">
									<app-tooltip-button
										text="Información adquirida a través de educación formal, eventos de capacitación o autoformación"
										img="/static/img/circle-question.svg"
										disabled
									></app-tooltip-button>
								</div>
							</p-title-header>
						</div>
						<table>
							<tr>
								<th style="width: 40%;">REQ.SELEC./CAP</th>
								<th style="width: 60%;">CONOCIMIENTO</th>
							</tr>
							<tr v-for="(rnw, index) in stepsData.RNW.description" :key="index">
								<td class="verb">{{ rnw.req.name }}</td>
								<td class="complement">{{ rnw.complement }}</td>
							</tr>
						</table>
					</div>
					<div v-if="stepsData.FINS" class="tw-flex tw-flex-col tw-mt-8">
						<div class="tw-flex tw-w-full tw-justify-between tw-gap-x-4">
							<button
							class="btn-primary">
							4
							</button>
							<p-title-header :title="stepsData.FINS.name" gray class="tw-w-full">
								<div class="tw-flex tw-w-full tw-justify-end tw-items-center" style="height: auto;">
									<app-tooltip-button
										text="Registra los títulos académicos formales necesarios para un adecuado desempeño del puesto."
										img="/static/img/circle-question.svg"
										disabled
									></app-tooltip-button>
								</div>
							</p-title-header>
						</div>
						<p-instruction-item
							v-for="(instruction, index) in stepsData.FINS.description.instructions"
							:key="index"
							class="tw-mt-6"
							:item="instruction"></p-instruction-item>
					</div>
					<div v-if="stepsData.EXPR" class="tw-flex tw-flex-col tw-my-8">
						<div class="tw-flex tw-w-full tw-justify-between tw-gap-x-4">
							<button
							class="btn-primary">
							5
							</button>
							<p-title-header :title="stepsData.EXPR.name" gray class="tw-w-full">
								<div class="tw-flex tw-w-full tw-justify-end tw-items-center" style="height: auto;">
									<app-tooltip-button
										text="Experiencias Laborales necesarias para el puesto."
										img="/static/img/circle-question.svg"
										disabled
									></app-tooltip-button>
								</div>
							</p-title-header>
						</div>
						<table>
							<tr>
								<th style="width: 40%;">EXPERIENCIA</th>
								<th style="width: 60%;">DETALLE</th>
							</tr>
							<tr v-for="(exp, index) in stepsData.EXPR.description" :key="index">
								<td class="verb">{{ exp.experience.name }}</td>
								<td class="complement">{{ exp.detail }}</td>
							</tr>
						</table>
					</div>
				</div>
				<div class="tw-flex-1 tw-w-full tw-p-3 column">
					<div v-if="stepsData.MECM" class="tw-flex tw-flex-col tw-mb-8">
						<div class="tw-flex tw-w-full tw-justify-between tw-gap-x-4">
							<button
							class="btn-primary">
							6
							</button>
							<p-title-header :title="stepsData.MECM.name" gray class="tw-w-full">
								<div class="tw-flex tw-w-full tw-justify-end tw-items-center" style="height: auto;">
									<app-tooltip-button
										text="Las responsabilidades a tener en consideración para el puesto."
										img="/static/img/circle-question.svg"
										disabled
									></app-tooltip-button>
								</div>
							</p-title-header>
						</div>
						<table>
							<tr>
								<th style="width: 60%;">RESPONSABILIDAD</th>
								<th colspan="3">
									<tr style="width: 100%;">
										<th colspan="3">RELEVANCIA</th>
									</tr>
									<tr>
										<th style="min-width: 100px !important;">ALTO</th>
										<th style="min-width: 100px !important;">MEDIO</th>
										<th style="min-width: 100px !important;">BAJO</th>
									</tr>
								</th>
							</tr>
							<tr v-for="(res, index) in stepsData.MECM.description" :key="index">
								<td class="verb1">
									<div class="tw-flex tw-justify-center">
										<span>{{ res.name }}</span> 
										<app-tooltip-button
											class="icon"
											size="18"
											:text="res.description"
											img="/static/img/info.svg"
											disabled
										></app-tooltip-button>
									</div>
								</td>
								<td class="complement1" v-for="(check, indexC) in res.checks" :key="indexC">
									<img src="/static/img/check.svg" v-if="check">
									<img src="/static/img/uncheck.svg" v-else>
								</td>
							</tr>
						</table>
					</div>
					<div v-if="stepsData.RQSK" class="tw-flex tw-flex-col tw-my-8">
						<div class="tw-flex tw-w-full tw-justify-between tw-gap-x-4">
							<button
							class="btn-primary">
							7
							</button>
							<p-title-header :title="stepsData.RQSK.name" gray class="tw-w-full">
								<div class="tw-flex tw-w-full tw-justify-end tw-items-center" style="height: auto;">
									<app-tooltip-button
										text="Son comportamientos laborales automatizados por la práctica en la ejecución de la actividad."
										img="/static/img/circle-question.svg"
										disabled
									></app-tooltip-button>
								</div>
							</p-title-header>
						</div>
						<div class="item-list">
							<div class="text-uppercase item-list-header tw-px-10 tw-py-1 tw-flex tw-justify-items-start tw-my-3 tw-gap-x-20">
								<span>NOMBRE DE DESTREZA</span>
							</div>
							<div class="tw-my-1" v-for="(skill, index) in stepsData.RQSK.description" :key="index">
								<p-card class="item-list-card tw-flex tw-justify-between tw-items-center">
										<p>{{ skill.name }}</p>
										<v-chip class="tags">
											{{ skill.selectedLevel.name }}
										</v-chip>
								</p-card>
							</div>
						</div>
					</div>
					<div v-if="stepsData.RDSK" class="tw-flex tw-flex-col tw-my-8">
						<div class="tw-flex tw-w-full tw-justify-between tw-gap-x-4">
							<button
							class="btn-primary">
							8
							</button>
							<p-title-header :title="stepsData.RDSK.name" gray class="tw-w-full">
								<div class="tw-flex tw-w-full tw-justify-end tw-items-center" style="height: auto;">
									<app-tooltip-button
										text="Se debe registrar las competencias propias del puesto conforme el Diccionario vigente."
										img="/static/img/circle-question.svg"
										disabled
									></app-tooltip-button>
								</div>
							</p-title-header>
						</div>
						<div class="item-list">
							<div class="text-uppercase item-list-header tw-px-10 tw-py-1 tw-flex tw-justify-items-start tw-my-3 tw-gap-x-20">
								<span>NOMBRE DE COMPETENCIAS</span>
							</div>
							<div class="tw-my-1" v-for="(competence, index) in stepsData.RDSK.description" :key="index">
								<p-card class="item-list-card">
										<div class="tw-flex tw-justify-between tw-items-center tw-gap-4">
											<div class="tw-flex tw-flex-col tw-justify-center tw-m-0 tw-p-0 tw-items-center">
												<p class="item-list-title-item tw-mb-0">{{ competence.name }}</p>
												<span class="item-list-subtitle-item tw-mb-0">{{ competence.parent.name }}</span>
											</div>
											<v-chip class="tags">
												{{ competence.selectedLevel.name }}
											</v-chip>
											
										</div>
										<p-horizontal-divider/>
										<div v-for="(question, indexQ) in competence.selectedQuestions" :key="indexQ">
											<p v-if="competence.questionsType.key === 'thirdPerson'">{{ question.thirdPerson }}</p>
											<p v-else>{{ question.firstPerson }}</p>
										</div>
								</p-card>
							</div>
						</div>
					</div>
					<div v-if="stepsData.RSID" class="tw-flex tw-flex-col tw-my-8">
						<div class="tw-flex tw-w-full tw-justify-between tw-gap-x-4">
							<button
							class="btn-primary">
							9
							</button>
							<p-title-header :title="stepsData.RSID.name" gray class="tw-w-full">
								<div class="tw-flex tw-w-full tw-justify-end tw-items-center" style="height: auto;">
									<app-tooltip-button
										text="Considere las actividades esenciales o los objetivos de trabajo relacionados con los objetivos de área y escriba ¿Cómo medir su correcta ejecución?"
										img="/static/img/circle-question.svg"
										disabled
									></app-tooltip-button>
								</div>
							</p-title-header>
						</div>
						<table>
							<tr>
								<th style="width: 15%;">CANT.</th>
								<th style="width: 65%;">CALIDAD</th>
								<th style="width: 20%;">TIEMPO</th>
							</tr>
							<tr v-for="(result, index) in stepsData.RSID.description" :key="index">
								<td class="result">{{ result.quantityPorcent }}</td>
								<td class="result">{{ result.quality }}</td>
								<td class="result">{{ result.quantity }} {{ result.time.name }}</td>
							</tr>
						</table>
					</div>
				</div>
			</p-card>
		</div>
	</div>
</template>

<script>
import titleHeader from '@/components/diagnosis/title-header';
import PTitleHeader from '@/modules/job-profile/components/content/p-title-header';
import PCard from '@/modules/shared/components/ui/Card/p-card';
import PButton from '@/modules/shared/components/ui/p-button';
import PInstructionItem from '@/modules/job-profile/components/content/p-instruction-item';
import PHorizontalDivider from '@/modules/shared/components/ui/p-horizontal-divider';
import helper from '@/shared/helper';
import { mapState } from 'vuex';
import { pathOr } from 'ramda';

const { getLocalData, generateBlob, showDownloadDialog } = helper;

function created() {
	this.loadData();
}

function mounted() {
}

async function loadData() {
	try {
		const { data: response } = await this.$httpPraktiko.get(`job-description/detail-profile/${this.selectedJob.id}`);
		this.jobInfo = response.additionalInformation || {};
		if (Object.keys(this.jobInfo).length === 0) {
			this.showNotification('Este Puesto no cuenta con su Descripción', 'warning');
			this.goTo('new-profile');
		}
		this.descriptionData = response;
		this.jobSelected = response.job;
		this.stepsData = response.steps;
		const responsables = this.stepsData.MECM.description;
		const dataResponsables = responsables.map((lr) => {
			const matchRes = this.responsability.find(r => r.id === lr.id);
			if (matchRes) {
				return {
					...lr,
					description: matchRes.description,
				};
			}
			return lr;
		});
		this.stepsData.MECM.description = dataResponsables;
	} catch (error) {
		if (error.status === 400) {
			if (error.data.message === 'JOB_PROFILE_NOT_FOUND') {
				this.showNotification('Este Puesto no cuenta con su Descripción', 'warning');
				this.goTo('new-profile');
			} else {
				this.showGenericError();
			}
		} else {
			this.showGenericError();
		}
	}
}

function downloadReport() {
	window.open(this.descriptionData.urlFile, '_blank');
}

async function downloadReportExcel({ type, contentType }) {
	const body = {
		jobId: this.selectedJob.id,
	};
	try {
		const { data: pdfData } = await this.$httpPraktiko.post('reports/job-profile/excel', body, { responseType: 'blob' });
		const blob = generateBlob(pdfData, contentType);
		showDownloadDialog(blob, `descripcion-puesto-${this.selectedJob.name}`, type);
		this.showNotification('Reporte Generado Exitosamente');
	} catch (error) {
		this.showGenericError();
	}
}

function getSubsidiaries() {
	const nameSubsidiaries = this.descriptionData.subsidiary.map(ds => ds.name);
	return nameSubsidiaries.length > 0 ? nameSubsidiaries.join(', ') : '';
}

function getJobsHeReplaces() {
	if (this.jobSelected.additionalInformation
		&& this.jobSelected.additionalInformation.jobHeReplaces
		&& this.jobSelected.additionalInformation.jobHeReplaces.length > 0) {
		const jobsHeReplaces = this.jobSelected.additionalInformation.jobHeReplaces
			.map(jHR => jHR.name);
		return jobsHeReplaces.length > 0 ? jobsHeReplaces.join(', ') : '';
	}
	return '';
}

function getJobsItReplaces() {
	if (this.jobSelected.additionalInformation
		&& this.jobSelected.additionalInformation.jobItReplaces
		&& this.jobSelected.additionalInformation.jobItReplaces.length > 0) {
		const jobsItReplaces = this.jobSelected.additionalInformation.jobItReplaces
			.map(jIR => jIR.name);
		return jobsItReplaces.length > 0 ? jobsItReplaces.join(', ') : '';
	}
	return '';
}

function returnPage() {
	return this.flagEditProcess ? this.goTo('list-process-recruitment') : this.goTo('new-profile');
}

function data() {
	return {
		descriptionData: {
			subsidiary: [],
			job: {},
			steps: {},
			urlFile: null,
		},
		jobInfo: {},
		stepsData: {
			MSJ: { description: [] },
			PSA: { description: [] },
			RNW: { description: [] },
			FINS: { description: { instructions: [] } },
			EXPR: { description: [] },
			MECM: { description: [] },
			RQSK: { description: [] },
			RDSK: { description: [] },
			RSID: { description: [] },
		},
		jobSelected: {
			name: '',
			role: { name: '' },
			areas: { name: '' },
			englishLevel: { name: '' },
			additionalInformation: {
				jobHeReplaces: [],
				jobItReplaces: [],
				immediateBoss: { name: '' },
			},
		},
	};
}

export default {
	name: 'details-job-description',
	data,
	created,
	beforeCreate() {
		this.$store.dispatch('jobProfile/loadResponsabilities');
	},
	mounted,
	components: {
		titleHeader,
		PTitleHeader,
		PCard,
		PButton,
		PInstructionItem,
		PHorizontalDivider,
	},
	methods: {
		loadData,
		downloadReport,
		downloadReportExcel,
		returnPage,
	},
	computed: {
		...mapState('jobProfile', {
			selectedJob(state) {
				return pathOr(getLocalData('selectedJob'), ['selectedJob'], state.jobProfile) || [];
			},
			responsability:
				pathOr([], ['descriptionData', 'responsabilities']),
		}),
		...mapState('recruitment', {
			flagEditProcess: pathOr(false, ['recruitmentFlow', 'flagEditProcess']),
		}),
		getSubsidiaries,
		getJobsHeReplaces,
		getJobsItReplaces,
	},
};

</script>

<style lang="scss" scoped>
.header {
	&-title {
		color: color(orange-dark);
		font-size: size(xlarge);
		text-transform: capitalize;
		font-weight: bold;
	}
	&-job {
		color: color(gray-sidebar);
		font-size: size(xlarge);
		text-transform: uppercase;
		font-weight: bold;
	}
}
.btn {
	&-primary{
		color: color(white) !important;
		background-color: color(green-light);
		font-family: font(bold);
		font-size: size(large);
		border-radius: 20px;
		width: 34px !important;
		height: 30px;
		padding: 0 !important;
		margin: 0 !important;
	}
	&-secondary{
		color: color(white) !important;
		background-color: color(orange-light);
		font-family: font(bold);
		font-size: size(large);
		border-radius: 20px;
		width: 24px !important;
		height: 24px;
		padding: 0 !important;
		margin: 0 !important;
	}
}

.column {
	table {
		margin: 10px 0;
		width: 100%;
		text-align: center;
		th {
			color: color(white);
			font-weight: font(bold);
			font-size: size(large);
			background-color: color(green-dark);
			border-radius: 4px;
		}
		tr {
			.verb {
				color: color(orange-dark) !important;
				font-size: size(large);
				padding: 10px 0;
				border-bottom: 1px solid color(border-gray);
			}
			.complement {
				color: color(gray-medium) !important;
				font-size: size(large);
				text-align: left !important;
				border-bottom: 1px solid color(border-gray);
			}
			.verb1 {
				color: color(orange-dark) !important;
				font-size: size(large);
				padding: 10px 0;
				position: relative;
				.icon {
					position: absolute;
					right: -15px;
					bottom: 2px;
				}
			}
			.complement1 {
				color: color(gray-medium) !important;
				font-size: size(large);
			}
			.result {
				color: color(gray-medium) !important;
				font-size: size(large);
				padding: 10px 0;
			}
		}

	}
}
.item-list {
	&-header {
		background-color: var(--app-color-primary);
		border-radius: 5px;
		span {
			color: white !important;
			font-weight: bold;
		}
	}
	&-card {
		margin: 0 !important;
		padding: 20px !important;
		p {
			color: color(gray-medium);
			font-size: size(large);
		}
		
	}
	&-title-item {
		font-size: size(sbig) !important;
		color: color(gray-sidebar) !important;
		font-family: font(bold);
	}
	&-subtitle-item {
		font-size: size(medium) !important;
		color: color(green-dark) !important;
		font-family: font(bold) !important;
	}
}
</style>


// WEBPACK FOOTER //
// src/modules/job-profile/pages/details-job-description/details-job-description.vue